import CommunitiesScene from './scenes/CommunitiesScene';

const routes = [
  {
    path: '/communities/*',
    component: CommunitiesScene,
    exact: false,
    menuName: 'communities',
    hasSomeRights: ['COMMUNITIES.MANAGE.ALL', 'COMMUNITIES.READ.ALL'],
    isActiveRoute: currentLocation => currentLocation.toLowerCase().startsWith('/communities'),
  },
];

export default routes;
